import Banner from './banner/index.vue';
import Finance from './finance/index.vue';
import Recommend from './recommend/index.vue';
import List from './list/index.vue';
import Query from './query/index.vue';
import Trade from './trade/index.vue';
import News from './news/index.vue';
import MapHotspot from './map-hotspot/index.vue';
import IndustrialLayout from './industrial-layout/index.vue';
import {mapMutations, mapGetters} from 'vuex';
import Service from '@/service/index.js';
import { isProvincialSites } from '@/utils/common.js';

export default {
  components: {
    Banner,
    Finance,
    Recommend,
    List,
    Query,
    Trade,
    News,
    IndustrialLayout,
    MapHotspot
  },
  data() {
    return {
      isShowMap: true,
      isShowNotice: true,
      count: 0
    };
  },
  computed: {
    ...mapGetters([
      'assetsBidInfos'
    ])
  },
  created() {
    // 子网站才展示
    this.isShowNotice = !isProvincialSites();

    Service.getSelectList('PROJECT_TYPE').then(res => {
      if (res && res.code === '0') {
        this.GET_PROJECT_TYPE(res.data);
      }
    });
    this.getActiveIndexLevel();
  },
  mounted() {
    if (this.count === 0 && document.documentElement.scrollTop) {
      document.documentElement.scrollTop = 0;
      this.count++;
    }
  },
  methods: {
    ...mapMutations([
      'GET_PROJECT_TYPE'
    ]),
    toDetailPage(type) {
      this.$router.push({path: '/about-us/market-member-detail', query: {id: type}});
    },
    goNewsList() {
      this.$router.push('/news/news-list/1');
    },
    goTrans() {
      this.$router.push('/transaction-pro/list');
    },
    // 竞价大厅查看更多
    goBidDetail() {
      this.$router.push('/bid-project');
    },

    getActiveIndexLevel() {
      let origin = window.location.href;
      let domainName;
      if(origin.split('//')[1].split('.')[0] === 'www') {
        domainName = origin.split('//')[1].split('.')[1];
      } else {
        domainName = origin.split('//')[1].split('.')[0];
        if(domainName.includes('localhost')) {
          domainName = 'localhost';
        }
      }
      Service.selectSiteInfoByDomain(domainName).then(res => {
        if (res.code === '0') {
          if(Number(res.data.level) === 4) {
            this.isShowMap = false;
          } else {
            this.isShowMap = true;
          }
          // this.isShowMap = (Number(res.level) !== 4 || domain.indexOf('localhost') >= 0);
        }
      });
    }
  }
};
